@if (open) {
  <div
    class="session-expired"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="session-expired-title"
    aria-describedby="session-expired-message"
  >
    <div class="session-expired__backdrop"></div>

    <div class="session-expired__panel">
      <div class="session-expired__icon" aria-hidden="true">
        <span class="session-expired__icon-clock">
          <app-clock-icon />
        </span>
        <span class="session-expired__icon-badge">!</span>
      </div>

      <h2 id="session-expired-title" class="session-expired__title">
        {{ 'session.expired.title' | translate }}
      </h2>

      <p id="session-expired-message" class="session-expired__message">
        {{ 'session.expired.message' | translate }}
      </p>

      <button type="button" class="session-expired__btn" (click)="onReconnect()">
        {{ 'session.expired.reconnect' | translate }}
      </button>
    </div>
  </div>
}
